import React from "react";
import _ from "lodash";
import {
  Button,
  CircularProgress,
} from "@material-ui/core";
import { useDeleteTagValue, useDeleteResourceTagValue } from "../data";

const DeleteItemButton = ({ onClick, disabled, loading }) => {
  return (
    <React.Fragment>
      {loading ? 
        <CircularProgress size={24} thickness={4} color="primary" style={{marginLeft : 8}}/>:
        <Button disabled={disabled} color="secondary" onClick={onClick}>
          Eliminar
        </Button>
      }
    </React.Fragment>
  );
};

const DeleteItemResource = ({ isDiabled, resource, tag, value, onCompleted = _.noop }) => {
  const [mutate, { loading, error }] = useDeleteResourceTagValue({ resource, tag, value, onCompleted });
  const disabled = isDiabled || loading || error;
  return <DeleteItemButton onClick={mutate} disabled={disabled} loading={loading} />;
};

const DeleteItemNotResource = ({ isDiabled, tag, value, contextId, contextType, onCompleted = _.noop }) => {
  const [mutate, { loading, error }] = useDeleteTagValue(tag, value, contextId, contextType, { onCompleted });
  const disabled = isDiabled || loading || error;
  return <DeleteItemButton onClick={mutate} disabled={disabled} loading={loading} />;
};

const DeleteItem = ({ isResource, isDiabled, contextId, contextType, tag, value, onCompleted }) => {
  if (isResource) {
    return (
      <DeleteItemResource
        isDiabled={isDiabled}
        resource={contextId}
        tag={tag}
        value={value}
        onCompleted={onCompleted}
      />
    );
  } else {
    return (
      <DeleteItemNotResource
        contextId={contextId}
        contextType={contextType}
        isDiabled={isDiabled}
        tag={tag}
        value={value}
        onCompleted={onCompleted}
      />
    );
  }
};

export default DeleteItem;



// WEBPACK FOOTER //
// ./src/components/tags-manager/tag-item/delete-item.js